import { proxy, useSnapshot } from 'valtio'
import { subscribeKey } from 'valtio/utils'
import { options, watchValue } from './optionsStorage'

export const currentScaling = proxy({
  scale: 1,
})
window.currentScaling = currentScaling

// The hotbar canvas is the widest HUD element and sets the ceiling for how far
// the interface can be scaled up before it runs off screen. Its width in HUD px
// depends on the offhand slot and the touch inventory button, so HotbarRenderApp
// reports the actual value here (210 = offhand, no touch button).
export const hotbarLayout = proxy({ hudWidth: 210 })
const HOTBAR_SIDE_MARGIN = 16

// `resize` already re-runs this: the scale has to follow the viewport, or a
// phone renders a hotbar wider than its own screen.
const setScale = () => {
  const desired = options.guiScale * 0.7
  const maxByWidth = window.innerWidth / (hotbarLayout.hudWidth + HOTBAR_SIDE_MARGIN)
  currentScaling.scale = Math.max(1, Math.min(desired, maxByWidth))
}

// Scale for the replay UI. #ui-root is scaled by --guiScale for the game HUD;
// dividing it back out keeps the GUI Scale setting off the player, and makes
// every `Npx * var(--s)` land as N real screen pixels.
const setUiScale = () => {
  const s = 1 / (currentScaling.scale || 1)
  document.documentElement.style.setProperty('--ui-scale', String(s))
}


setScale()
setUiScale()
subscribeKey(options, 'guiScale', setScale)
subscribeKey(hotbarLayout, 'hudWidth', setScale)
watchValue(currentScaling, (c) => {
  document.documentElement.style.setProperty('--guiScale', String(c.scale))
  document.documentElement.style.setProperty('--scale', String(c.scale))
  setUiScale()
})
window.addEventListener('resize', setScale)

export const useAppScale = () => {
  return useSnapshot(currentScaling).scale
}
